import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectService } from '../../../../../../core/services/project.service';
import { HttpService } from '../../../../../../core';
import { environment } from '../../../../../../../environments/environment';
import { MatRadioChange } from '@angular/material/radio';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-floorplan-dialog',
  templateUrl: './floorPlanDialog.component.html',
  styleUrls: ['./floorPlanDialog.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})

export class FloorPlanDialogComponent implements OnInit {
  projectId: any;
  propertyId: any;
  floorPlans = [];
  projectCode: any;
  SERVER_URL = environment.SERVER_URL;
  selection: any;
  isFloorPlanChosen: boolean;
  chosenFloorPlanId: any;
  showAllFloorPlan: boolean;


  constructor(private dialogRef: MatDialogRef<any>,
    private httpService: HttpService,
    private projectService: ProjectService,
    private toastrService: ToastrService,
    // private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }
  ngOnInit(): void {
    console.log(this.data);
    this.projectId = this.data.projectId;
    this.propertyId = this.data.propertyId;
    this.projectCode = this.data.projectCode;
    // this.selection = this.data.floorPlan ? this.data.floorPlan.id : '';
    console.log(this.selection);
    this.httpService.getAllFloorPlansByProjectId(this.projectId).subscribe((res: any) => {
      console.log(res);
      if (res.data.length > 0) {
        this.showAllFloorPlan = true;
        const temp = JSON.parse(JSON.stringify(res.data));
        this.floorPlans = temp.filter(floorPlan => floorPlan.images.length > 0);
        this.selection = this.data.floorPlan ? this.data.floorPlan.id : '';
        console.log(this.selection);
      } else {
        this.showAllFloorPlan = false;
      }
    });
  }


  closeDialog() {
    this.dialogRef.close();
  }

  updateProperty() {
    this.dialogRef.close();
  }

  radioChange(mrChange: MatRadioChange) {
    this.chosenFloorPlanId = parseInt(mrChange.value, 10);
    console.log(this.chosenFloorPlanId, this.selection);
    this.isFloorPlanChosen = true;
  }

  AttachFloorPlan() {
    const fd = new FormData();
    fd.append('floorPlanId', this.selection);
    this.httpService.updateProperty(this.propertyId, fd).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        const attachedFloorPlan = this.floorPlans.filter((floorPlan) => {
          return floorPlan.id === this.selection;
        })[0];
        console.log(attachedFloorPlan);
        this.dialogRef.close({ attachedFloorPlan });
        this.toastrService.success('Adding floor plan to this property successful.');
      } else if (res.code === 0) {
        this.dialogRef.close();
        this.toastrService.error('Failed to add floor plan to this property.');
      }
    });
  }

  encodeURI(url) {
    return encodeURI(url);
  }
}
